import React from 'react';
import ConfigStore from '../stores/configStore';

const ProfileElementField = ({ element, subsection = false, children }) => {
  const { activeProfileElements } = ConfigStore.useState(state => state);

  if (!activeProfileElements.includes(element)) return <></>;

  return subsection ? (<div className="my-5">{children}</div>) : children;
};

export default ProfileElementField;
